
import Button from '../base/Button';

export default function Header() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="text-2xl font-bold text-orange-500" style={{ fontFamily: '"Pacifico", serif' }}>
              ちょこっとハウス
            </div>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('features')}
              className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
            >
              特徴
            </button>
            <button 
              onClick={() => scrollToSection('reasons')}
              className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
            >
              選ばれる理由
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
            >
              お問い合わせ
            </button>
          </nav>
          
          <Button 
            onClick={() => scrollToSection('contact')}
            size="sm"
          >
            資料請求・無料相談
          </Button>
        </div>
      </div>
    </header>
  );
}
